import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ocr row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "OCR", -1)
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "progress" }
const _hoisted_6 = { class: "small muted" }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = {
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link active",
  id: "nav-im-url-tab",
  "data-toggle": "tab",
  href: "#nav-im-url",
  role: "tab",
  "aria-controls": "nav-im-url",
  "aria-selected": "true"
}, "Image URL", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  id: "nav-im-upload-tab",
  "data-toggle": "tab",
  href: "#nav-im-upload",
  role: "tab",
  "aria-controls": "nav-im-upload",
  "aria-selected": "false"
}, "Image Upload", -1)
const _hoisted_11 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_12 = {
  class: "tab-pane fade show active",
  id: "nav-im-url",
  role: "tabpanel",
  "aria-labelledby": "nav-im-url-tab"
}
const _hoisted_13 = { class: "input-group mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "imageUrl"
  }, "URL")
], -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  class: "tab-pane fade",
  id: "nav-im-upload",
  role: "tabpanel",
  "aria-labelledby": "nav-im-upload-tab"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "input-group mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "-- IMAGE LANG --", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "File")
], -1)
const _hoisted_23 = {
  class: "tab-pane fade",
  id: "nav-video",
  role: "tabpanel",
  "aria-labelledby": "nav-video-tab"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "Video OCR", -1)
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = {
  id: "videoCamera",
  style: {"width":"400px","height":"300px"},
  autoplay: "",
  playsinline: "",
  ref: "videoCamera"
}
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = {
  id: "videoImage",
  src: "",
  style: {"max-width":"400px","max-height":"300px"},
  ref: "videoImage"
}
const _hoisted_31 = {
  id: "videoCanvas",
  style: {"display":"none"},
  ref: "videoCanvas"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "small" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "video not supported on your device/browser.")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "row"
}
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = { class: "small" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "confidence: ", -1)
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "col-md-10" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", null, "OCR Results", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.logger && Math.round(_ctx.logger.progress*100)!=100)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "progress-bar progress-bar-striped bg-success",
                role: "progressbar",
                style: _normalizeStyle('width: '+Math.round(_ctx.logger.progress*100)+'%')
              }, _toDisplayString(Math.round(_ctx.logger.progress*100)) + "%", 5)
            ]),
            _createElementVNode("p", _hoisted_6, "status: " + _toDisplayString(_ctx.logger.status), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("nav", null, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("a", {
              class: "nav-link",
              id: "nav-video-tab",
              "data-toggle": "tab",
              href: "#nav-video",
              role: "tab",
              "aria-controls": "nav-video",
              "aria-selected": "false",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enableVideo()))
            }, "Video")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "aria-label": "Image Url",
              "aria-describedby": "imageUrl",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.imageUrl) = $event))
            }, null, 512), [
              [_vModelText, _ctx.imageUrl]
            ]),
            _createElementVNode("button", {
              class: "btn btn-danger",
              id: "ocrImageUrl",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ocrImageUrl())),
              disabled: !_ctx.imageUrl
            }, "OCR", 8, _hoisted_15)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  id: "language",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLanguage) = $event))
                }, [
                  _hoisted_20,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportedLanguages, (l) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: l.code,
                      value: l.code
                    }, _toDisplayString(l.name), 9, _hoisted_21))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedLanguage]
                ]),
                _hoisted_22,
                _createElementVNode("input", {
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ocrImageFile && _ctx.ocrImageFile(...args))),
                  class: "form-control",
                  type: "file",
                  accept: "image/*"
                }, null, 32)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          (_ctx.hasGetUserMedia())
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      class: "btn btn-danger col-md-12",
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.snapShot()))
                    }, "Snapshot"),
                    _createElementVNode("video", _hoisted_28, null, 512)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("img", _hoisted_30, null, 512),
                    _createElementVNode("canvas", _hoisted_31, null, 512)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
        ])
      ]),
      (_ctx.hocr)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("p", _hoisted_37, [
                _hoisted_38,
                _createTextVNode(_toDisplayString(_ctx.confidence), 1)
              ]),
              _createElementVNode("div", { innerHTML: _ctx.hocr }, null, 8, _hoisted_39)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode(_component_editor, {
                modelValue: _ctx.hocr,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.hocr) = $event)),
                "api-key": "8kpycxhjheir0b2odz6yw1kfsyxo9pm6qtaa0u5temvzej6u",
                id: "src",
                init: {
                        menubar: false,
                        plugins: 'lists link image emoticons paste code',
                        toolbar: 'styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link image emoticons | removeformat | code',
                        paste_as_text: true
                    },
                placeholder: "Type text to convert"
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}